module.exports = __webpack_public_path__ + "img/12-1.09fd6c31.png";